/* prettier-ignore */

import { computed, inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NewCustomRouteService } from 'src/app/pages/new-custom-route/new-custom-route.service';

@Injectable({ providedIn: 'root' })

export class ShowComponentService {
    private _router = inject(Router);
    private _customRouteService = inject(NewCustomRouteService);
    private customRouteData = computed<boolean>(() => this._customRouteService.route()?.length);
    
    private guardExistCustomRouteData = () => {
        return this.customRouteData()
            ? null
            : { 
                is_successful: false, 
                reason: 'No hay ruta generada' 
            };
    };

    private guardInCustomRouteView = () => {
        return this._router.url.includes('custom-route')
            ? null
            : { 
                is_successful: false, 
                reason: 'No estás en la vista de la ruta' 
            };
    };

    private guardIsMobile = () => {
        const isMobile = window.innerWidth <= 800;
        return isMobile
            ? null
            : { 
                is_successful: false, 
                reason: 'En modo escritorio siempre está disponible la vista' 
            };
    };

    private runWithGuards(guards: Array<() => any>, action: () => void) {
        for (const g of guards) {
            const res = g();
            if (res) 
                return res;
        }
        action();
        return { 
            is_successful: true 
        };
    }

    public showTimelineComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView, 
                this.guardIsMobile
            ],
            () => {
                this._customRouteService.showTimeline?.update(prev => true);
            }
        );
    }

    public showMapComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView, 
                this.guardIsMobile
            ],
            () => {
                this._customRouteService.showTimeline?.update(prev => false);
            }        
        );
    }

    public showSendRouteComponent() {
        return this.runWithGuards(
            [
                this.guardExistCustomRouteData, 
                this.guardInCustomRouteView
            ],
            () => {
                this._router.navigateByUrl('/send-update-route');
            }        
        );
    }
    
}